import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { ClassificationsPage } from './_dashboard.catalog.classifications'

export const Route = createFileRoute('/_dashboard/catalog/classifications/$item')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: ClassificationsItemPage,
})

function ClassificationsItemPage() {
  const { item } = Route.useParams()
  return <ClassificationsPage selectedId={item} />
}
